<template>
  <div class="pagination">
    <div class="pagination__wrap">
      <div v-if="gridList" class="pagination__inner-wrap">
        <div class="pagination__grid" :class="gridClass">
          <svg @click="setGrid(GridClass.LIST)">
            <use xlink:href="#icon-th-solid"></use>
          </svg>
          <svg @click="setGrid(GridClass.CARDS)">
            <use xlink:href="#icon-th-large-solid"></use>
          </svg>
        </div>
        <form class="category-page__form">
          <select
              v-model="sortBy"
              class="category-page__select"
          >
            <option v-for="option in sortOptions" :key="option.id" :value="option">{{ option.name }}</option>
          </select>
        </form>
      </div>

      <div v-else class="pagination__btn-wrap">
        <div
            @click="prev"
            class="pagination__next"
            v-if="currentPage > 1"
        >
          <svg>
            <use xlink:href="#icon-caret-left-solid"></use>
          </svg>
          Prev
        </div>
        <div
            @click="next"
            class="pagination__next"
            :class="{ disable: currentPage === maxPage }"
        >
          Next
          <svg>
            <use xlink:href="#icon-caret-right-solid"></use>
          </svg>
        </div>
        <p class="main-text">
          Total Found: <strong>{{ total }}</strong>
        </p>
      </div>

      <div class="pagination__input-wrap">
        <svg @click="prev">
          <use xlink:href="#icon-chevron-left-light"></use>
        </svg>
        <input
            type="number"
            min="1"
            :max="maxPage"
            v-model="currentPage"
            class="pagination__input"
        />
        <svg @click="next">
          <use xlink:href="#icon-chevron-right-light"></use>
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useProductStore} from "../../store/product.ts";
import {storeToRefs} from "pinia";
import {GridClass, SortDirection, SortField, SortOption} from "../../utils/types.ts";
import {computed, ref, Ref, WritableComputedRef} from "vue";

interface Props {
  gridList?: boolean;
}

withDefaults(defineProps<Props>(), {
  gridList: false
});

const sortOptions: SortOption[] = [
  {id: SortField.ALTITUDE, name: "Altitude Greatest", sort: SortDirection.DESC},
  {id: SortField.ALTITUDE, name: "Altitude Smallest", sort: SortDirection.ASC},
  {id: SortField.CREATED_AT, name: "Most Recent", sort: SortDirection.DESC},
  {id: SortField.CREATED_AT, name: "Oldest", sort: SortDirection.ASC}
]

const productStore = useProductStore()
const {setGrid, setRequest} = productStore
const {gridClass, prodRequest, maxPage, total} = storeToRefs(productStore)
const sortInput: Ref<SortOption> = ref({id: SortField.CREATED_AT, name: "Most Recent", sort: SortDirection.DESC})

const sortBy: WritableComputedRef<SortOption> = computed({
  get: () => sortInput.value,
  set: (value) => {
    const newSort = prodRequest.value.sort
    newSort[0] = [value.id, value.sort]
    setRequest({...prodRequest.value, sort: newSort})
  },
})

const currentPage: WritableComputedRef<number> = computed({
  get: () => prodRequest.value.page,
  set: (value: number) => {
    setRequest({...prodRequest.value, page: value})
  },
})

function scrollTo(){
  document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });
}

function next() {
  if (currentPage.value >= maxPage.value) return
  currentPage.value++
  scrollTo()
}

function prev() {
  if (currentPage.value <= 1) return
  currentPage.value--
  scrollTo()
}
</script>
